import React from 'react';
import classNames from 'classnames';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentArticleHit as Type } from '../../../../SearchAllContent/types';
import constructImageSourcesArray from '../../../../../helpers/constructImageSources';
import { epochToDateString } from '../../../../../helpers';
import useLayoutVariables from '../../../../../hooks/useLayoutVariables';

import Card from '../../../../Card';

import './style.scss';

const MetaSearchArticleHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('MetaSearchHit', 'MetaSearchArticleHit');

  const {
    heroImageAspectRatio,
  } = useLayoutVariables('articleTeaser');

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Image
          image={(
            <Image
              src={constructImageSourcesArray(hit, heroImageAspectRatio)}
              alt={hit.image_alt?.[0]}
              lazyload={false}
            />
          )}
        />

        <div className="MetaSearchArticleHit__text-wrapper">
          <div className="Card__content__metadata">
            {hit.article_type_name?.[0] && (
              <div className="MetaSearchArticleHit__article-type">
                <Card.Tags tags={[{ type: 'article_type_name', name: hit.article_type_name[0] }]} />
              </div>
            )}
            {hit.publish_date?.[0] && (
              <span className="MetaSearchArticleHit__article-publish-date">
                {epochToDateString(hit.publish_date[0], hit.langcode[0])}
              </span>
            )}
          </div>

          <div className="Card__content__body">
            <Card.Link href={hit.url[0]}>
              <Card.Title title={hit.page_title[0]} />
            </Card.Link>

            <Card.Subtitle
              subtitle={(
                <p className="u-truncate--3">
                  {hit.body_summarized?.[0] ? (
                    hit.body_summarized[0]
                  ) : (
                    hit.body?.[0]
                  )}
                </p>
              )}
            />
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default MetaSearchArticleHit;
